export const ABLY_CONNECTION_STATUS = {
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
};
